import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "menu"
}

import { computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'Menu',
  setup(__props) {

const store = useStore();
const auth = computed(() => store.state.auth);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", null, [
    (auth.value && auth.value.isUser)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, { to: "/blog" }, {
              default: _withCtx(() => [
                _createTextVNode(" Blog ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, { to: "/application" }, {
              default: _withCtx(() => [
                _createTextVNode(" Applications ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, { to: "/learn" }, {
              default: _withCtx(() => [
                _createTextVNode(" Learn ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, { to: "/note" }, {
              default: _withCtx(() => [
                _createTextVNode(" Notes ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, { to: "/lesson" }, {
              default: _withCtx(() => [
                _createTextVNode(" Lessons ")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})